
const pluralize = (count, singular) =>
    `${count} ${singular}${count !== 1 ? 's' : ''}`;

export default pluralize;
